// @ts-nocheck
import dom from "../../dom2.js";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const dontTreeShakeDom = dom;
import {PROJECT_TOPIC_MENU_JS_SELECTOR} from "../../project-topic-menu.js";

/**
 * @param {Object}   props
 * @param {function} props.onClickTopic
 * @param {boolean}  props.selected
 * @param {Object}   props.topic
 * @return {HTMLElement}
 */
const TopicButton = props => {
	const topicUuid = props.topic.uuid;

	return (
		<li className="topic-item">
			<button
				className={"btn-topic js-btn-topic" + (props.selected ? " selected" : "")}
				data-tippy-content={props.topic.label}
				data-uuid={topicUuid}
				onClick={() => props.onClickTopic(topicUuid)}
				onKeyDown={handleKeyDown}
				type="button"
			>
				<i className="aa-icon-circle aa-icon-mask" style={{backgroundColor: "#" + props.topic.color}}></i>
				<span className="topic-text">{props.topic.label}</span>
			</button>
		</li>
	);
};

/**
 * Tab: jumps to action buttons on tab
 * Up/down arrow keys: travels through the list of topic buttons
 *
 * @param  {object} event
 */
const handleKeyDown = function (event) {
	const key = event.key;

	if (key === "Tab" || key === "ArrowUp" || key === "ArrowDown") {
		event.preventDefault();
		const parent = event.target.parentNode;

		if (key === "Tab") {
			if (event.shiftKey) // Go backwards
				document.querySelector(PROJECT_TOPIC_MENU_JS_SELECTOR).shadowRoot.querySelector(".project-item.selected .btn-project").focus();
			else // Go forwards
				document.querySelector(PROJECT_TOPIC_MENU_JS_SELECTOR).shadowRoot.querySelector(".btn-actions").focus();
		} else if (key === "ArrowUp") {
			if (parent.previousSibling)
				parent.previousSibling.firstChild.focus();
		} else if (key === "ArrowDown") {
			if (parent.nextSibling)
				parent.nextSibling.firstChild.focus();
		}
	}
};

export default TopicButton;
